import { render } from "./ChatBox.vue?vue&type=template&id=20964c55&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"

import "./ChatBox.vue?vue&type=style&index=0&id=20964c55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20964c55"]])

export default __exports__